export const navTabs = [
  { id: 'best', label: 'Home', icon: 'play-circle' },
  { id: 'categories', label: 'Categories', icon: 'grid', dropdown: true },
  { id: 'terbaru', label: 'Bokep Terbaru', icon: 'clock' },
  { id: 'trending', label: 'Trending', icon: 'trending-up' },
  { id: 'cerita', label: 'Cerita Dewasa', icon: 'book-open' },
];

export const countryCategories = [
  'Indonesia', 'Japan', 'Korea', 'Thailand', 'China',
  'Vietnam', 'Philippines', 'Malaysia', 'India', 'Western',
];

export const categories = [
  { id: 1, name: 'Indonesia' },
  { id: 2, name: 'Japan' },
  { id: 3, name: 'Korea' },
  { id: 4, name: 'Thailand' },
  { id: 5, name: 'China' },
  { id: 6, name: 'Vietnam' },
  { id: 7, name: 'Philippines' },
  { id: 8, name: 'Malaysia' },
  { id: 9, name: 'India' },
  { id: 10, name: 'Western' },
];

export const formatViews = (num) => {
  if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M';
  if (num >= 1000) return (num / 1000).toFixed(1) + 'k';
  return num.toString();
};

export const videos = [];
